import { render, staticRenderFns } from "./OrdemDeServico.vue?vue&type=template&id=12dfef5d"
import script from "./OrdemDeServico.vue?vue&type=script&lang=js"
export * from "./OrdemDeServico.vue?vue&type=script&lang=js"
import style0 from "./OrdemDeServico.vue?vue&type=style&index=0&id=12dfef5d&prod&scped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports